import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=3315dd4d&scoped=true&"
import script from "./Speed.vue?vue&type=script&lang=js&"
export * from "./Speed.vue?vue&type=script&lang=js&"
import style0 from "./Speed.vue?vue&type=style&index=0&id=3315dd4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315dd4d",
  null
  
)

export default component.exports